import { gql } from '@apollo/client';

export const PAGE_QUERY_REALTIME_SETTLEMENT_DAILY_SUM = gql`
  query PageQueryRealtimeSettlementDailySum(
    $filters: RealtimeSettlementOrderDailySumFilterTypeInput
    $page: Int!
    $pageSize: Int!
  ) {
    pageQueryRealtimeSettlementDailySum(filters: $filters, page: $page, pageSize: $pageSize) {
      list {
        id
        clientId
        clientName
        orderCount
        dailyDate
        currency
        sumAmount
        timezone
      }
      total
    }
  }
`;
